// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setDefaultEnabled(
  ydb: Database,
  fieldId: string,
  defaultEnabled: boolean
): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];

    field.defaultEnabled = defaultEnabled;
  });
}
